import api from './client'

export async function fetchAllocationBoard(params = {}) {
  const { data } = await api.get('/allocation/board', { params })
  return data
}

export async function fetchUnassignedTasks() {
  const { data } = await api.get('/allocation/unassigned')
  return data
}

export async function assignTask(body) {
  const { data } = await api.post('/allocation/assign', body)
  return data
}

export async function fetchEmployeeAvailabilityForRange({ employee_id, start_date, end_date, exclude_task_id, exclude_job_id }) {
  const params = { start_date, end_date }
  if (exclude_task_id !== undefined && exclude_task_id !== null) params.exclude_task_id = exclude_task_id
  if (exclude_job_id !== undefined && exclude_job_id !== null) params.exclude_job_id = exclude_job_id
  const { data } = await api.get(`/availability/${employee_id}/range`, { params })
  return data
}

export async function updateTaskAllocation({ task_id, ...body }) {
  const { data } = await api.patch(`/allocation/assign/${task_id}`, body)
  return data
}

export async function recalculateBoardAvailability({ month, employee_ids, start_date, end_date }) {
  const params = {}
  if (start_date && end_date) {
    params.start_date = start_date
    params.end_date = end_date
  } else if (month) {
    params.month = month
  }
  const { data } = await api.post('/allocation/recalculate', { employee_ids }, { params })
  return data
}

export async function fetchJobPool() {
  const { data } = await api.get('/allocation/job-pool')
  return data
}

export async function assignJob(body) {
  const { data } = await api.post('/allocation/assign-job', body)
  return data
}

export async function updateJobAllocation({ job_id, ...body }) {
  const { data } = await api.patch(`/allocation/assign-job/${job_id}`, body)
  return data
}

export async function refreshEmployeeAvailability({ employee_id, start_date, end_date }) {
  const { data } = await api.post(`/availability/${employee_id}/refresh`, { start_date, end_date })
  return data
}
